export default {
    // common_text
    c_home: "Trang chủ",
    c_homeAdmin: "Trang chủ quản trị",
    c_create: "Thêm mới",
    c_list: "Danh sách",
    c_update: "Cập nhật",
    c_delete: "Xóa",
    c_deletes: "Xóa nhiều",
    c_detail: "Chi tiết",
    c_duplicate: "Sao chép",
    c_download: "Tải xuống",
    c_view: "Xem",
    c_hide: "Ẩn",
    c_close: "Đóng",
    c_search: "Tìm kiếm",
    c_filter: "Lọc dữ liệu",
    c_back: "Quay lại",
    c_success: "thành công",
    c_error: "thất bại",
    c_record: "bản ghi",
    c_fromDate: "Từ ngày",
    c_toDate: "Đến ngày",
    c_order: "Xắp xếp",
    c_drag: "Kéo thả",
    c_select: "Chọn",
    c_typeKeyToSearch: "Nhập từ khoá để tìm kiếm",
    c_agree: "Đồng ý",
    c_approve: "Duyệt",
    c_disapprove: "Từ chối",
    c_cancel: "Huỷ",
    c_sendTcqltt: "Gửi đến TCQLTT",
    c_showHideSearch: "Ẩn/hiện tìm kiếm",
    c_toggle: "Thu nhỏ/phóng to",
    c_action: "Thao tác",
    c_total: "Tổng số",
    c_toPage: "Đến trang",
    c_enter: "Nhập",
    c_yes: "Có",
    c_no: "Không",
    c_selectLeader: "Chọn làm trưởng đoàn",
    c_changeStatus: "Chuyển trạng thái",
    c_showCheckin: "Check in",
    c_showQrcode: "QR code",
    c_showTaiapp: "Tải app",
    c_exportExcel: "Xuất excel",
    c_manage: "Quản lý",
    c_sign: "Ký",
    c_config: "Cấu hình",
    c_sync: "Đồng bộ",
    c_recall: "Thu hồi",
    c_giveComment: "Cho ý kiến",
    c_consult: "Xin ý kiến",
    c_transfer: "Chuyển",
    c_publish: "Ban hành",

    // common_alert
    c_addSuccess: "Thêm mới thành công",
    c_addError: "Thêm mới thất bại",
    c_addduplicateError: "Mã đã tồn tại, không thể thêm mới",
    c_updateSuccess: "Cập nhật thành công",
    c_updateError: "Cập nhật thất bại",
    c_deleteSuccess: "Xóa thành công",
    c_deleteError: "Xóa thất bại",
    c_uploadError: "Tải lên thất bại",
    c_recordSuccess: "bản ghi thành công",
    c_recordError: "bản ghi thất bại",
    c_deleteConfirm: "Bạn có chắc chắn muốn xóa bản ghi này không?",
    c_deleteEmployeeConfirm: "Bạn có chắc chắn muốn xóa nhân viên này không?",
    c_approveConfirm: "Bạn có chắc chắn muốn duyệt bản ghi này không?",
    c_disapproveConfirm: "Bạn có chắc chắn muốn từ chối bản ghi này không?",
    c_notAllowAccess: "Không có quyền truy cập trang này",
    c_emptyRecord: "Bạn chưa chọn bản ghi nào",
    c_loginAgain: "Bạn cần đăng nhập trước",
    c_findError: "Lỗi tải dữ liệu",
    c_uploadConfirm: "Xác nhận upload file?",
    c_selectLeaderConfirm: "Bạn có chắc chắn muốn chọn khách du lịch này làm trưởng đoàn?",
    c_unselectLeaderConfirm: "Bạn có chắc chắn muốn bỏ chọn trưởng đoàn này?",
    c_addCodeSuccess: "Xử lý hoàn tất",
    c_publishConfirm: "Bạn có chắc chắn muốn ban hành tin tức này?",
    c_resetOriginalRole: "Bạn có muốn phân quyền về mặc định ?",

    // validation
    valid: "Được phép",
    valid_required: "Vui lòng nhập giá trị",
    valid_requiredChange: "Vui lòng chọn giá trị",
    valid_email: "Email không đúng định dạng",
    valid_phone: "Điện thoại không đúng",
    valid_link: "Liên kết không đúng định dạng",
    valid_imageLink: "Liên kết ảnh không đúng định dạng",
    valid_sign: "Không được nhập ký tự có dấu",
    valid_space: "Không được nhập ký tự trắng",
    valid_script: "Không được nhập ký tự đặc biệt",
    valid_az09: "Chỉ được nhập a-z, 0-9",
    valid_az09Dot: "Chỉ được nhập a-z, 0-9, dấu chấm",
    valid_account: "Nhập a-z, 0-9, dấu chấm và @",
    valid_textFirst: "Ký tự đầu tiên phải là chữ",
    valid_floatNegative: "Không được nhập số âm",
    valid_dateTime: "Ngày giờ không đúng định dạng",
    valid_date: "Ngày không đúng định dạng",
    valid_year: "Năm không đúng định dạng",
    valid_month: "Tháng không đúng định dạng",
    valid_number: "Chỉ được nhập số 0-9",
    valid_integer: "Chỉ được nhập số nguyên",
    valid_float: "Chỉ được nhập số nguyên hoặc số thập phân",
    valid_tuNgay: "Từ ngày phải nhỏ hơn hoặc bằng đến ngày",
    valid_denNgay: "Đến ngày phải lớn hơn hoặc bằng từ ngày",
    valid_upload: "Vui lòng chọn file",
    valid_file: "file",
    valid_character: "ký tự",
    valid_max: "Không được lớn hơn",
    valid_min: "Không được nhỏ hơn",
    valid_length: "Giá trị nhập phải là",
    valid_requiredUpload: "Vui lòng chọn",
    valid_password: "Nhập tổi thiểu 6 ký tự",
    valid_insert: "Nhập từ",
    valid_to: "đến",
    valid_insertThan: "Nhập lớn hơn",
    valid_insertLess: "Nhập nhỏ hơn",
    valid_compareTime: "TG bắt đầu phải nhỏ hơn TG kết thúc",
    valid_compareStartEndTime: "TG bắt đầu và kết thúc phải trong khoảng TG bắt đầu và kết thúc tour",
    valid_compareTimeThongBao: "Thời điểm tạo phải nhỏ hơn thời điểm hết hạn",

    // login
    login: "Đăng nhập",
    login_error: "Tên đăng nhập hoặc mật khẩu không đúng",
    login_account: "Tên đăng nhập",
    login_password: "Mật khẩu",
    login_remember: "Ghi nhớ đăng nhập",

    // logout
    logout: "Đăng xuất",
    logout_all: "Có đăng xuất khỏi các thiết bị khác?",
    logout_success: "Đăng xuất thành công",
    logout_error: "Đăng xuất thất bại",

    //change password
    c_changePasswordSuccess: "Đổi mật khẩu thành công",
    c_changePasswordError: "Đổi mật khẩu thất bại",
    c_changePasswordErrorOld: "Mật khẩu cũ không đúng",
    c_changePasswordErrorReEnterNew: "Mật khẩu nhập lại không khớp",
    c_changePasswordErrorOldNew: "Mật khẩu mới không được trùng với mật khẩu cũ",
    c_resetPassword: "Đặt lại mật khẩu",
    c_resetPasswordSuccess: "Đặt lại mật khẩu thành công",
    c_resetPasswordError: "Đặt lại mật khẩu thất bại",
};
